<div class="main-painel">
    <div class="title-panel">
        Integração de Arquivo Sankhya
    </div>
    <mat-divider></mat-divider>
    <div class="info">
        Configuração preparada para Inserção de Arquivos no ERP Sankhya
    </div>
    <mat-divider></mat-divider>
    <mat-stepper orientation="horizontal">
        <mat-step>
            <ng-template matStepLabel>Início</ng-template>
            <ng-template matStepContent>
                <form [formGroup]="formGroup">
                    <div class="main-container"> 
                        <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name='sankhyainstance'>
                        </ngx-spinner>

                        <expanse-panel title="Origem dos Dados" [open]="true">
                            <search-input  [loaddesc]="true" ignoreDefCondition="false" entityname="Mktpdic" [form]="formGroup"  [condition]="conditionSearch" entitydesc="Tabela de Entidades" controlname="origem" placeholder="Tabela" fieldname="INSTANCENAME" columnname="IDINSTANCE" class="no-padding-form-field-5px"
                            matTooltip="Informar a Entidade de Busca de Dados da TemAPI" matTooltipClass="toolTip-request" >
                            </search-input>
                            <mat-form-field  appearance="outline" class="no-padding-form-field-5px full-width" >
                                <mat-label>Condição para Busca de Dados</mat-label>
                                <input  tabindex="1" type = "text" matInput formControlName="filter" placeholder="Condição para busca de dados ( Ex: campo1 = 'a' and campo2 ='b')"  #inpFilter matTooltip="Indicar a condição para busca de dados para alteração" matTooltipClass="toolTip-request"> 
                                <button    tabindex="-1"  type="button" *ngIf="inpFilter.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpFilter.value=''" >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </expanse-panel>
                        
                        <expanse-panel title="Destino dos Dados" [open]="true">
                            <mat-slide-toggle formControlName="useCustomValidationQuery" >
                                Usa Validação Customizada
                            </mat-slide-toggle>
                            <mat-divider></mat-divider>
                            <mat-form-field class="no-padding-form-field-5px full-width">
                                <mat-label>Destino</mat-label>
                                <input type="text"
                                       placeholder="Instância Destino"
                                       aria-label="destino"
                                       matInput
                                       formControlName  ="destino"
                                       [matAutocomplete]="auto">
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                  <mat-option *ngFor="let option of destinoFilteredOptions | async" [value]="option['NAME']">
                                    {{option['NAME']}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            <mat-divider></mat-divider>
                            <div class="validationQueryDiv" >
                                <mat-form-field appearance="outline" class="no-padding-form-field-5px full-width">
                                    <mat-chip-grid #chipGridValidationQueryFields aria-label="Seleção de Campos" [formControl]="validationFormFields" >
                                        <mat-chip-row *ngFor="let field of validationQueryFieldsList" (removed)="removeChip(field)"
                                        selected
                                        removable
                                        [selectable]="selectable"
                                        color="primary">
                                            {{field}}
                                        <button matChipRemove [attr.aria-label]="'remove ' + field">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                        </mat-chip-row>
                                        <input placeholder="Novo Campo..." #validat 
                                        [matChipInputFor]="chipGridValidationQueryFields" 
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        (matChipInputTokenEnd)="addChip($event)"/>
                                    </mat-chip-grid>                                    
                                </mat-form-field>
                                <mat-form-field  appearance="outline" class="no-padding-form-field-5px full-width" >
                                    <mat-label>Condição de Validação de Dados no Sankhya</mat-label>
                                    <input  tabindex="1" type = "text" matInput formControlName="validationQueryCondition" placeholder="Condição para busca de dados ( Ex: campo1 = 'a' and campo2 ='b')"  #validationQueryFilter matTooltip="Indicar a condição de validação de dados na entidade de destino do Sankhya" matTooltipClass="toolTip-request"> 
                                    <button    tabindex="-1"  type="button" *ngIf="validationQueryFilter.value" matSuffix mat-icon-button aria-label="Clear"  (click)="validationQueryFilter.value=''" >
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>
                                <form-array-component [formulario]="formGroup" formArrayName="returnField" [formConfiguration]="returnValueConfiguration" title="Tratamento de Retorno">

                                </form-array-component>
                            </div>
                            <div class="validationQueryDiv" *ngIf="formGroup.get('useCustomValidationQuery').value">
                                <form-array-component [formulario]="formGroup" formArrayName="customValidationQuery" [formConfiguration]="returnValueConfiguration" title="Tratamento de Retorno">

                                </form-array-component>
                            </div>
                        </expanse-panel>
                    </div>
                </form>
            </ng-template>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Transformação</ng-template>
            <ng-template matStepContent>
            </ng-template>            
        </mat-step>
    </mat-stepper> 
    <mat-divider></mat-divider>


</div>